/**
 * VehicleDetails
 * Handles all JS stuff for vehicle examination detail page
 */
export default class VehicleDetails {

    // constructor
    constructor(selector) {

        let _this = this;
        this.$plugin = $(selector);

        // cancel if non existing element
        if (this.$plugin.length === 0) {
            return false;
        }

        this.$result = this.$plugin.find('[data-tncp-vehicleexaminationslist="results"]');
        if (this.$result.length > 0) {
            this.getResults();

            // on form submit
            this.$plugin.on('submit', '[data-tncp-vehicleexaminationslist="filterForm"]', () => {
                this.$plugin.find('[data-tncp-pagination-value]').val(''); // resets the pagination on filter change
                this.getResults(); // load results
                return false;
            });
        }
    }

    // get results
    getResults() {
        let vm = this;
        let $form = this.$plugin.find('[data-tncp-vehicleexaminationslist="filterForm"]');
        let serializedFilters = btoa($form.serialize());
        const formData = new FormData();
        return new Promise(function(resolve, reject) {
            formData.append("tx_tuevnordcustomerportal_api[filter]", serializedFilters);

            vm.$plugin.find('[data-form--isloading]').attr('data-form--isloading', 'true');

            vm.request = window.xhrRequest({
                url: $form.attr('action'),
                method: 'POST',
                data: formData
            });
            vm.request.then((response) => {
                vm.$result.html(response.data.content);
            vm.$plugin.find('[data-form--isloading]').attr('data-form--isloading', 'false');

                resolve(response);
            });
            vm.request.catch((e) => {
                reject(e);
            });
        });
    }

    // disable all form fields
    disableForm($form, disable = true) {
        let $selectors = $form.find('button, input, select, textarea');
        if (disable === true) {
            $selectors.attr('disabled', true);
        } else {
            $selectors.removeAttr('disabled');
        }
    }

    // synchronize values and submit ob change
    synchronizeValues(selector) {
        let vm = this;
        $(selector).change(function() { // listen on change of selector
            let $vm = $(this); // this jquery obj
            $(selector).val($vm.val()); // seems weird, but changes the values of all form elements with the same selector
            vm.getResults();
        });
    }
}